import { Dayjs } from 'dayjs';

import { NumberRangeValue } from 'ui/form/number-range-input';

export const displayTypes = {
  graph: 'graph',
  table: 'table',
} as const;

export type DisplayType = keyof typeof displayTypes;

export type SaveGraphSetForm = {
  title: string;
};

export type GraphByPeriodFilters = {
  startDate: Dayjs;
  endDate: Dayjs;
};

export type GraphFilters = {
  dateFilters: GraphByPeriodFilters;
  ringFilters: NumberRangeValue;
};

export const parameterFamilyKeyPrefix = 'parameterFamilyKeyPrefix';

export type DataPoint = { date: number } & { [key: string]: number };
